import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import InfiniteCalendar from 'react-infinite-calendar';
import moment from 'moment';
import { slotActions } from '../../store/actions';
import Footer from '../../components/Footer/footer';
import '../../static/css/slot.css';
import 'react-infinite-calendar/styles.css';
import { Spring } from 'react-spring';
import Swal from 'sweetalert2';
import HeaderComponent from '../../components/Header';
import Loading from '../../components/Loading/Loading';
import { calculatePageSlots, findSlot, history } from '../../helpers';
import DatePickerDesktop from './DatePickerDesktop';
import DatePickerMobile from './DatePickerMobile';
import { constants } from '../../Constants';
import { throttle } from 'lodash';
import ProjectSelectionModal from '../../components/RegisterSlotUpdateModal';
import ReactDOMServer from "react-dom/server";

class CounselorDatePicker extends Component {
	constructor(props) {
		super(props);

		this.state = {
			date: [],
			day: [],
			selected_date_time: [],
			selected_date: false,
			dayRequired: 7,
			startingPoint: 1,
			startingpage: 1,
			pageName: 'one',
			one: [[]],
			two: [[]],
			three: [[]],
			four: [[]],
			requested_patient_email: '',
			isDragStart: false, // Tracks if dragging has started.
			dragData: null, // Data of the dragged project.
			dragedSlots: [], // Slots where projects are dragged.
		};
		this.throttledHandleMouseMove = throttle(this.handleMouseMove, 150);
	}

	componentDidMount() {
		const email = this.props.match.params.email ? this.props.match.params.email : "";
		this.setState({
			requested_patient_email: email
		})
	}

	componentWillMount() {
		if (this.props.user.user !== undefined) {
			if (this.props.user.user.role === 1) {
				history.replace('/home');
			} else {
				const { user_id } = this.props.user.user;
				this.props.fetchTimeSlots(user_id);
			}
		}
	}
	componentWillReceiveProps(nextProps) {
		if (this.props.user.error){
			return false;
		}
		const { projects } = this.props.user.user; //Counsellor's allocated projects
		const array = [];
		if (nextProps.all_slots.slotRequest === false) {
			for (var i = 0; i < nextProps.all_slots.items.length; i++) {
				const { project_id } = nextProps.all_slots.items[i];
				const date = nextProps.all_slots.items[i].date_time;
				//project
				let projectName = '';
				let project = null;
				if (project_id && project_id.indexOf(',') > -1) {
					const allProjects = project_id.split(',');
					allProjects.forEach((p) => {
						project = projects.find((f) => f.id === p);
						projectName += project && project.name + ',';
					});
				} else {
					project = !!project_id ? projects.find((f) => f.id === project_id) : undefined;
					projectName = project && project.name;
				}

				const date1 = moment(date).format('YYYY-MM-DD HH:00:00');

				project && array.push({ date: date1, project: projectName.replace(/,\s*$/, '') });
			}
			this.setState(
				{
					selected_slots: array,
				},
				() => {
					this.setDateandTime(1);
				}
			);
		}
	}

	setDateandTime = (pageNumber, selectedSlot = null) => {
		const date = [];
		const daysRequired = this.state.dayRequired;
		const hoursRequred = 23;
		const day = [];
		const hours = [];
		const daysHours = [];
		const startingPoint = this.state.startingPoint;
		let arrayname = pageNumber;

		if (arrayname === 1) {
			arrayname = 'one';
			this.setState({
				pageName: 'one',
			});
		}
		if (arrayname === 2) {
			arrayname = 'two';
			this.setState({
				pageName: 'two',
			});
		}

		if (arrayname === 3) {
			arrayname = 'three';
			this.setState({
				pageName: 'three',
			});
		}
		if (arrayname === 4) {
			arrayname = 'four';
			this.setState({
				pageName: 'four',
			});
		}

		for (let i = startingPoint; i <= daysRequired; i++) {
			date.push({
				date: moment().add(i, 'days').format('DD MMM'),
				clicked: false,
			});
			day.push({
				desktop: moment().add(i, 'days').format('dddd'),
				mobile: moment().add(i, 'days').format('dd'),
			});
		}
		this.setState({
			date: date,
		});
		this.setState({
			day: day,
		});

		/* Hours */
		var d = new Date();
		var n = d.getHours();
		const checked = false;

		for (let v = startingPoint; v <= daysRequired; v++) {
			for (let i = 0; i <= hoursRequred; i++) {
				const obj = {
					hour: moment().add(i, 'hour').add(v, 'days').subtract(n, 'hours').format('YYYY-MM-DD HH:00:00'),
					checked: false,
					disabled: false,
				};
				const { selected_slots } = this.state;
				const slotExists = selected_slots.filter((f) => f.date === obj.hour);
				if (slotExists.length > 0) {
					obj.project = selected_slots.find((f) => f.date === obj.hour).project;
					obj.disabled = true;
				}
				if (selectedSlot && obj.hour === selectedSlot.hour) {
					obj.project = selectedSlot.projects;
					obj.checked = true;
				}
				hours.push(obj);
			}
			daysHours.push(hours.slice(hours.length - 24, hours.length));
		}

		moment().hour(24);
		if (this.state[arrayname] < 1) {
			this.setState({
				[arrayname]: daysHours,
			});
		}
	};
	checkpopupCheckbox = () => {
		alert('he;p');
	};

	loadPage = (pageNumber, slot, pageName, v, u) => {
		const array = [...this.state[pageName]];
		if (Array.isArray(array) && array.length === 7) {
			array[v][u]['checked'] = true;
			array[v][u]['project'] = slot.projects;
			this.setState({
				[pageName]: array,
			});
		}
		const baseStartingPoint = 1;
		const baseDaysRequired = 7;
		const startingPoint = baseStartingPoint + (pageNumber - 1) * baseDaysRequired;
		const dayRequired = startingPoint + baseDaysRequired - 1;
		this.setState({
			startingpage: pageNumber,
			startingPoint: startingPoint,
			dayRequired: dayRequired,
		}, () => {
			this.setDateandTime(pageNumber, slot);
		});
	};

	handleChange = (data, v, u) => {
		const { pageName } = this.state;
		const array = [...this.state[pageName]];
		const previouslySelectedProjects = array[v][u].project && array[v][u].project.split(",").map(s => s.trim()) || [];
		const sortedProjects = this.props.user.user.projects.sort((a, b) => {
			return a.name.localeCompare(b.name);
		});
		const date =
			this.state.date.filter((a) => a.clicked).length > 0
				? `${this.state.date.filter((a) => a.clicked)[0].date} ${moment().year()} ${data.split(' ')[1]}`
				: data;
		const selected_date = moment(date).format('YYYY-MM-DD HH:00:00');
		let selectedTimestamp = moment(data, "YYYY-MM-DD HH:mm:ss");

		Swal.fire({
			title: constants.CHOOSE_YOUR_PROJECT,
			html: ReactDOMServer.renderToString(
				<ProjectSelectionModal
					projects={sortedProjects}
					dateTime={data}
					selectedProjects={previouslySelectedProjects}
					state={this.state}
				/>
			),
			reverseButtons: true,
			showCancelButton: true,
			confirmButtonColor: 'rgba(48, 86, 167, 0.87)',
			cancelButtonColor: '#d33',
			cancelButtonText: 'Cancel',
			confirmButtonText: 'Ok',
			backdrop: false,
			customClass: {
				popup: 'custom-modal-parent',
				actions: 'custom-button-container',
				confirmButton: 'custom-action-button',
				cancelButton: 'custom-action-button'
			},
			onOpen: () => {
				const scrollY = window.scrollY;
				document.body.style.position = 'fixed';
				document.body.style.top = `-${scrollY}px`;
				document.body.style.width = '100%';
				const backdrop = document.createElement('div');
				backdrop.className = 'custom-backdrop';
				document.body.appendChild(backdrop);
				backdrop.addEventListener('click', () => Swal.close());
				const popup = Swal.getPopup();
				const cancelBtn = popup.querySelector('.swal2-cancel');
				const confirmBtn = popup.querySelector('.swal2-confirm');
				if (cancelBtn) cancelBtn.setAttribute('id', 'btnCancelCreateSlotProject');
				if (confirmBtn) confirmBtn.setAttribute('id', 'btnConfirmCreateSlotProject');
				const selectAll = Swal.getPopup().querySelector("#selectAllCheckbox");
				const projectCheckboxes = Swal.getPopup().querySelectorAll(".popup-project-checkbox");
				selectAll.addEventListener("change", (event) => {
					const isChecked = event.target.checked;
					projectCheckboxes.forEach((checkbox) => {
						checkbox.checked = isChecked;
					});
					document.getElementById("selectAllLabel").innerText = isChecked ? "Unselect All" : "Select All";
				});

				projectCheckboxes.forEach((checkbox) => {
					checkbox.addEventListener("change", () => {
						const allChecked = Array.from(projectCheckboxes).every(projectBox => projectBox.checked);
						selectAll.checked = allChecked;
						document.getElementById("selectAllLabel").innerText = allChecked ? "Unselect All" : "Select All";
					});
				});
				const datePicker = document.getElementById("datePicker");
				const timePicker = document.getElementById("timePicker");
				const datePickerWrapper = document.getElementById('datePickerWrapper');
				datePicker && datePicker.addEventListener("change", () => {
					selectedTimestamp = moment(
						`${datePicker.value} ${selectedTimestamp.format("HH:mm")}`,
						"YYYY-MM-DD HH:mm"
					);
				});

				timePicker && timePicker.addEventListener("change", () => {
					selectedTimestamp = moment(
						`${selectedTimestamp.format("YYYY-MM-DD")} ${timePicker.value}`,
						"YYYY-MM-DD HH:mm"
					);
				});

				datePickerWrapper && datePickerWrapper.addEventListener("click", () => {
					datePicker.showPicker();
				});

			},
			onClose: () => {
				const scrollY = Math.abs(parseInt(document.body.style.top || '0', 10));
				document.body.style.position = '';
				document.body.style.top = '';
				document.body.style.width = '';
				window.scrollTo(0, scrollY);
				const backdrop = document.querySelector('.custom-backdrop');
				if (backdrop) backdrop.remove();
			},
			preConfirm: () => {
				const projects = this.props.user.user.projects;
				let checked = [];
				const updatedHour = moment(selectedTimestamp).format('YYYY-MM-DD HH:mm:ss');
				if (updatedHour !== array[v][u]['hour']) {
					const mergedAllSlots = [
						...this.state.selected_slots.map(({ date, project }) => ({ time: date, project })),
						...this.state.selected_date_time.map(({ time, project }) => ({ time: time, project }))
					];
					const isAlreadyExist = mergedAllSlots.some((slot) =>
						moment(slot.time).format('YYYY-MM-DD HH:mm:ss') === moment(updatedHour).format('YYYY-MM-DD HH:mm:ss')
					);
					if (isAlreadyExist) {
						Swal.showValidationMessage("Slot Already exists.");
						return [];
					}
				}
				projects.forEach((p) => {
					var obj = {};
					const element = Swal.getPopup().querySelector(`#project-${p.id}`);
					obj['checked'] = element ? element.checked : false;
					obj['name'] = p.name;
					obj['id'] = p.id;
					checked.push(obj);
				});
				return checked.filter((c) => c.checked).length > 0
					? checked
					: [];
			},
		}).then((result) => {
			if (!!result.value) {
				// result will show all the checked projects
				//  check if date has been selected from mobile
				if (!this.state.selected_date) {
					const isAnyProjectSelected = Array.isArray(result.value) && result.value.some(project => project.checked) || false;
					const slotDetail1 = moment(selectedTimestamp).utc().format();
					if (!isAnyProjectSelected) {
						const updatedSlots = this.state.selected_date_time.filter(slot => slot.time !== slotDetail1);
						array[v][u] = {
							...array[v][u],
							checked: false,
							project: '',
						};
						this.setState({
							selected_date: false,
							selected_date_time: updatedSlots
						});
						Swal.close();
						return;
					}
					let project_selected = '';
					result.value.forEach((p) => {
						if (p.checked) project_selected += p.name.trim() + ',';
					});
					project_selected = project_selected.replace(/,\s*$/, '');
					const updatedHour = moment(selectedTimestamp).format('YYYY-MM-DD HH:mm:ss');
					if (updatedHour !== array[v][u]['hour']) {
						const pages = ["one", "two", "three", "four"];
						let foundPage = null, foundV = null, foundU = null;
						for (let i = 1; i <= pages.length; i++) {
							const pageData = calculatePageSlots(i);
							const result = findSlot(pageData, updatedHour);
							if (result) {
								foundV = result.dayIndex;
								foundU = result.hourIndex;
								foundPage = i;
								break;
							}
						}
						if (foundPage !== null && foundV !== null && foundU !== null) {
							v = foundV;
							u = foundU;
							this.loadPage(foundPage, {
								hour: updatedHour,
								projects: project_selected,
							}, pages[foundPage - 1], v, u);
						}
					}
					else {
						array[v][u]['checked'] = isAnyProjectSelected;
						array[v][u]['project'] = project_selected;
						this.setState({ [pageName]: array });
					}
					const slotDetails = { time: slotDetail1, project: project_selected };
					if (this.state.selected_date_time.indexOf(slotDetails) > -1) {
						const array = this.state.selected_date_time.filter((e) => e !== slotDetails);
						this.setState({
							selected_date_time: array,
						});
					} else {
						this.setState((prevState) => {
							const isAlreadyExist = prevState.selected_date_time.some(
								(slot) =>
									moment(slot.time).format('YYYY-MM-DD HH:00:00') === selected_date
							);
							if (isAlreadyExist) {
								const updatedSlots = prevState.selected_date_time.map((slot) =>
									moment(slot.time).format('YYYY-MM-DD HH:00:00') === selected_date
										? { ...slot, ...slotDetails }
										: slot
								);
								return { selected_date_time: updatedSlots };
							} else {
								return {
									selected_date_time: [...prevState.selected_date_time, slotDetails],
								};
							}
						});
					}
				} else {
					const date =
						this.state.date.filter((a) => a.clicked).length > 0
							? `${this.state.date.filter((a) => a.clicked)[0].date} ${moment().year()} ${data.split(' ')[1]}`
							: data;
					const selected_date = moment(date).format('YYYY-MM-DD HH:00:00');

					array[1][v]['selected'] = !array[0][v]['selected'];

					let project_selected = '';
					result.value.forEach((p) => {
						if (p.checked) project_selected += p.name + ',';
					});
					project_selected = project_selected.replace(/,\s*$/, '');
					array[1][v]['project'] = project_selected;

					const slotDetail1 = moment(selected_date).utc().format();
					const slotDetails = { time: slotDetail1, project: project_selected };
					this.setState((prevState) => ({
						selected_date_time: [...prevState.selected_date_time, slotDetails],
					}));
					this.setState({ [pageName]: array });
				}
			}
		});
	};
	validateSlots = (slots) => {
		let flag = false;
		const currentTime = moment().add('24', 'hours'); //.utc().format();
		for (let n = 0; n < slots.length; n++) {
			//slots.forEach((s,i) => {
			flag = moment(slots[n].time).isAfter(currentTime); //moment(s).get('hour') - currentTime.get('hours') > 24;
			if (!flag) return;
		}
		return flag;
	};
	createSlot = () => {
		const slotDetails = this.state.selected_date_time;
		const req_patient_email = this.state.requested_patient_email;

		if (slotDetails.length > 0) {
			const isValidSlots = this.validateSlots(slotDetails);
			if (!isValidSlots) {
				Swal.fire('Saaya Health', 'Please create a slot that is at least 24 hours ahead.', 'error');
				return;
			}
			Swal.fire({
				title: 'Are you sure?',
				text: 'You want to create selected slot!',
				type: 'question',
				reverseButtons: true,
				showCancelButton: true,
				confirmButtonColor: '#36A692',
				cancelButtonColor: '#d33',
				cancelButtonText: 'No',
				confirmButtonText: 'Yes',
				onOpen: function () {
					Swal.getPopup().querySelector('.swal2-cancel').setAttribute('id', 'btnCancelCreateSlot');
					Swal.getPopup().querySelector('.swal2-confirm').setAttribute('id', 'btnConfirmCreateSlot');
				},
			}).then((result) => {
				if (result.value) {
					let slots = [];

					const { projects } = this.props.user.user;
					const user_id = JSON.parse(localStorage.getItem('user')).counsellor_id;

					slotDetails.forEach((slot) => {
						let slotProjects = slot.project;
						if (slotProjects.indexOf(',') > -1) {
							slotProjects = slotProjects.split(',');
							let projectsString = '';
							for (let a = 0; a < slotProjects.length; a++) {
								const project = projects.find((f) => f.name.trim() === slotProjects[a].trim());
								projectsString += project.id + ',';
							}
							const newSlot = {
								date_time: slot.time,
								project_id: projectsString.replace(/,\s*$/, ''),
							};
							slots.push(newSlot);
						} else {
							const project = projects.find((f) => f.name.trim() === slotProjects.trim());
							const newSlot = {
								date_time: slot.time,
								project_id: project.id,
							};
							slots.push(newSlot);
						}
					});
					const payload = {
						counsellor_id: user_id,
						current_time: moment(new Date()).utc().format(),
						slots: slots,
						req_patient_email: req_patient_email
					};
					this.props.createTimeSlot(payload);
				}
			});
		} else {
			Swal.fire('Saaya Health', 'Please select any slot timing!', 'error');
		}
	};

	arrowRightClick = () => {
		if (this.state.startingpage !== 4) {
			this.setState((prevState) => ({
				startingpage: prevState.startingpage + 1,
			}));

			this.setState(
				(prevState) => ({
					dayRequired: prevState.dayRequired + 7,
					startingPoint: prevState.startingPoint + 7,
				}),
				() => {
					this.setDateandTime(this.state.startingpage);
				}
			);
		}
	};

	arrowLeftClick = () => {
		if (this.state.startingpage !== 1) {
			const startingpage = this.state.startingpage - 1;
			this.setState({
				startingpage: startingpage,
			});
			if (this.state.dayRequired !== 7 && this.state.startingPoint !== 1) {
				this.setState(
					(prevState) => ({
						dayRequired: prevState.dayRequired - 7,
						startingPoint: prevState.startingPoint - 7,
					}),
					() => {
						this.setDateandTime(startingpage);
					}
				);
			}
		}
	};
	isSlotSelected(slot, isDraging = false) {
		if (slot.disabled) {
			return {
				backgroundColor: 'rgba(58, 165, 147, 0.1)',
				color: '#3AA593',
				fontWeight: '400',
				cursor: 'none',
				padding: '10px',
				disabled: true,
				cursor: 'no-drop',
				pointerEvents: 'none',
				textAlign: 'center',
				borderLeft: '2px solid #3AA593'
			};
		}
		if (slot.checked) {
			return {
				backgroundColor: '#3AA593',
				color: 'white',
				// fontWeight: "400",
				cursor: `${isDraging ? 'se-resize' : 'none'}`,
				padding: '10px',
				pointerEvents: 'all',
				textAlign: 'center'
			};
		} else if (!slot.is_selected) {
			return {
				padding: '10px',
				pointerEvents: 'all',
				cursor: 'pointer',
			};
		}
	}

	cancelSlot = () => {
		Swal.fire({
			title: 'Are you sure?',
			text: 'You want to go back !',
			type: 'question',
			reverseButtons: true,
			showCancelButton: true,
			confirmButtonColor: '#36A692',
			cancelButtonColor: '#d33',
			cancelButtonText: 'No',
			confirmButtonText: 'Yes',
			onOpen: function () {
				Swal.getPopup().querySelector('.swal2-cancel').setAttribute('id', 'btnCancelGoBackSlot');
				Swal.getPopup().querySelector('.swal2-confirm').setAttribute('id', 'btnGoBackSlot');
			},
		}).then((result) => {
			if (result.value) {
				history.push('/home/counsellor');
			} else {
			}
		});
	};

	onDateClicked = (v, i) => {
		const date_array = [...this.state.date];
		date_array.map((v, i) => {
			v.clicked = false;
		});
		date_array[i]['clicked'] = !date_array[i]['clicked'];

		this.setState({
			date: date_array,
			selected_date: v,
		});
	};

	handleMouseMove = (e) => {
		e.preventDefault();
		e.stopPropagation();
		const slotDiv = e.target.closest('td[id^="slot-"]');
		if (!slotDiv) {
			return;
		}
		const slotId = slotDiv.id;
		const match = slotId.match(/^slot-(\d+)-(\d+)-(.+)$/);
		if (!match || !slotId) {
			return;
		}
		const [, col, row, data] = match;
		const colIndex = parseInt(col, 10);
		const rowIndex = parseInt(row, 10);
		const { pageName, dragData } = this.state;
		const array = [...this.state[pageName]];
		if (dragData && Array.isArray(array) && array.length > 0 && colIndex >= 0 && rowIndex >= 0) {
			const slotDetails = array[colIndex][rowIndex] || null;
			if (slotDetails && !slotDetails.disabled && !slotDetails.isChecked) {
				const clickedDates = this.state.date.filter((dateItem) => dateItem.clicked);
				const date = clickedDates.length > 0 ?
					`${clickedDates[0].date} ${moment().year()} ${data.split(' ')[1]}`
					: data;
				const selected_date = moment(date).format('YYYY-MM-DD HH:00:00');
				array[colIndex][rowIndex] = {
					checked: 'true',
					disabled: false,
					hour: selected_date,
					project: dragData.project
				};
				this.setState((prevState) => {
					const { dragedSlots } = prevState;
					const isDuplicate = dragedSlots.some(
						(slot) => moment(slot.time).format('YYYY-MM-DD HH:00:00') === selected_date
					);
					if (!isDuplicate && selected_date !== dragData.hour) {
						return {
							dragedSlots: [
								...dragedSlots,
								{
									time: moment(data).utc().format(),
									project: dragData.project,
								},
							],
						};
					}
					return prevState;
				});
			}
		}
	};

	handleMouseUp = () => {
		const { dragedSlots } = this.state;
		if (Array.isArray(dragedSlots) && dragedSlots.length > 0) {
			this.setState((prevState) => {
				const updatedSlots = [...prevState.selected_date_time];
				dragedSlots.forEach((draggedSlot) => {
					const existingSlotIndex = updatedSlots.findIndex((slot) => slot.time === draggedSlot.time);
					if (existingSlotIndex > -1) {
						updatedSlots[existingSlotIndex] = {
							...updatedSlots[existingSlotIndex],
							...draggedSlot,
						};
					} else {
						updatedSlots.push(draggedSlot);
					}
				});
				return { selected_date_time: updatedSlots };
			});
		}
		this.setState({
			dragData: null,
			isDragStart: false,
			dragedSlots: [],
		});
		document.removeEventListener("mousemove", this.throttledHandleMouseMove);
		document.removeEventListener("mouseup", this.handleMouseUp);
	};

	handleResizeStart = (e, colIndex, rowIndex) => {
		const { pageName } = this.state;
		const array = [...this.state[pageName]];
		const selectedSlot = array[colIndex][rowIndex] || null;
		if (colIndex >= 0 && rowIndex >= 0) {
			this.setState({
				dragData: selectedSlot,
				isDragStart: true,
			});
			document.addEventListener("mousemove", this.throttledHandleMouseMove);
			document.addEventListener("mouseup", this.handleMouseUp);
		}
	};

	render() {
		const pagename = this.state.pageName;
		const array = this.state[pagename];
		if (array.length > 1) {
			return (
				<div className="sh-layout">
					<HeaderComponent />

					<div className="sh-slot-picker-comp">
						{/* Welcome Note */}
						<div className="sh-gnrl-welcome-note sh-add-note">
							<h2 className="sh-gnrl-welcome" id="">
								REGISTER SLOTS
							</h2>
							{/* <div className="swal2-content">Please mark your available slots for a 2 weeks window. It's a good idea to give a few options to the client.</div> */}
						</div>
						<div className="add-note">
							<div className="swal2-content">Please mark your available slots for a 2 weeks window. It's a good idea to give a few options to the client.</div>
						</div>
						<div className="sh-slot-picker-table">
							<DatePickerDesktop
								arrowLeftClick={this.arrowLeftClick}
								arrowRightClick={this.arrowRightClick}
								day={this.state.day}
								date={this.state.date}
								array={array}
								isSlotSelected={this.isSlotSelected}
								handleChange={this.handleChange}
								handleResizeStart={this.handleResizeStart}
								isDrageStart={this.state.isDragStart}
								handleMouseMove={this.throttledHandleMouseMove}
								handleMouseUp={this.handleMouseUp}
							/>
						</div>

						<div className="sh-slot-picker-button">
							<button
								onClick={this.cancelSlot}
								className="sh-gnrl-btn back-btn"
								id="btnGoBackSlots"
							>
								Go Back
							</button>
							<button
								onClick={this.createSlot}
								className="sh-gnrl-btn create-btn"
								id="btnCreateSlot"
							>
								Create
							</button>
						</div>

					</div>

					<Footer />
				</div>
			);
		} else {
			return <Loading />;
		}
	}
}

const mapStateToProps = (state) => {
	return {
		user: state.auth,
		users: state.users,
		item: state.item,
		all_slots: state.slots,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchTimeSlots: (counsellor_id) => {
			dispatch(slotActions.fetchTimeSlots(counsellor_id));
		},
		createTimeSlot: (slotDetails) => dispatch(slotActions.createTimeSlot(slotDetails)),
	};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CounselorDatePicker));



// WEBPACK FOOTER //
// ./src/screens/CounselorDatePicker/index.js